"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MathPlaceholder_exports = {};
__export(MathPlaceholder_exports, {
  default: () => MathPlaceholder_default
});
module.exports = __toCommonJS(MathPlaceholder_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.875 16.5C14.9531 16.487 15.0312 16.4609 15.1094 16.4219C15.1875 16.3828 15.2526 16.3307 15.3047 16.2656C15.3698 16.2005 15.4154 16.1289 15.4414 16.0508C15.4805 15.9727 15.5 15.8945 15.5 15.8164V13.3359C15.487 13.2448 15.4609 13.1602 15.4219 13.082C15.3828 13.0039 15.3307 12.9388 15.2656 12.8867C15.2005 12.8346 15.1224 12.7956 15.0312 12.7695C14.9531 12.7305 14.8685 12.7109 14.7773 12.7109H14.6797C14.5885 12.724 14.5039 12.75 14.4258 12.7891C14.3607 12.8151 14.2956 12.8607 14.2305 12.9258C14.1654 13.0039 14.1198 13.082 14.0938 13.1602C14.0677 13.2253 14.0547 13.3034 14.0547 13.3945V15.1133H7.41406L10.9492 10.543L10.9883 10.4648C11.0404 10.4128 11.0729 10.3542 11.0859 10.2891C11.099 10.224 11.099 10.1589 11.0859 10.0938C11.0859 10.0286 11.0729 9.96354 11.0469 9.89844C11.0208 9.83333 10.9883 9.77474 10.9492 9.72266L7.43359 5.38672H14.0547V7.16406C14.0547 7.25521 14.0742 7.33984 14.1133 7.41797C14.1523 7.49609 14.2109 7.5612 14.2891 7.61328C14.3542 7.66536 14.4258 7.71094 14.5039 7.75C14.5951 7.77604 14.6862 7.78906 14.7773 7.78906C14.8815 7.78906 14.9727 7.77604 15.0508 7.75C15.1419 7.71094 15.2201 7.65885 15.2852 7.59375C15.3633 7.52865 15.4154 7.45703 15.4414 7.37891C15.4805 7.28776 15.5 7.19661 15.5 7.10547V4.60547C15.487 4.52734 15.4609 4.45573 15.4219 4.39062C15.3828 4.3125 15.3307 4.24089 15.2656 4.17578C15.2005 4.1237 15.1224 4.08464 15.0312 4.05859C14.9531 4.01953 14.8685 4 14.7773 4H6.45703C6.3138 4.01302 6.18359 4.04557 6.06641 4.09766C5.96224 4.14974 5.86458 4.22135 5.77344 4.3125C5.68229 4.40365 5.61719 4.50781 5.57812 4.625C5.53906 4.72917 5.51953 4.84635 5.51953 4.97656L5.53906 5.07422C5.53906 5.1263 5.53906 5.17839 5.53906 5.23047C5.55208 5.26953 5.57161 5.30859 5.59766 5.34766C5.61068 5.38672 5.63021 5.42578 5.65625 5.46484C5.68229 5.50391 5.70182 5.53646 5.71484 5.5625L9.44531 10.1523L5.69531 14.957L5.65625 15.0352C5.57812 15.1393 5.52604 15.25 5.5 15.3672C5.48698 15.4844 5.49349 15.6016 5.51953 15.7188C5.54557 15.8359 5.59115 15.9466 5.65625 16.0508C5.73438 16.1419 5.82552 16.2266 5.92969 16.3047C5.96875 16.3307 6.00781 16.3568 6.04688 16.3828C6.09896 16.4089 6.15755 16.4284 6.22266 16.4414C6.27474 16.4674 6.32682 16.487 6.37891 16.5C6.43099 16.5 6.48307 16.5 6.53516 16.5H14.875Z",
      fill: "currentColor"
    }
  )
);
const SvgMathPlaceholder = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MathPlaceholder_default = SvgMathPlaceholder;
